import React from "react";
import { useDispatch } from "react-redux";
import {
  CHANGE_DCA_NO_LIMIT_FUND,
  CHANGE_DCA_ORDER,
  CHANGE_FUND,
} from "../../../../actions/create-bot-type";

const DcaParamsView = (props) => {
  const { newBot, currentCoin,t } = props;
  const dispatch = useDispatch();
  const changeDcaNoLimit = (val) => {
    dispatch({
      type: CHANGE_DCA_NO_LIMIT_FUND,
      payload: val,
    });
  };
  const changeDcaOrder = (val) =>
    dispatch({
      type: CHANGE_DCA_ORDER,
      payload: val,
    });
  return (
    <div>
      <div>
        <input
          type="checkbox"
          checked={newBot.dcaNoLimitFund}
          onChange={(e) => changeDcaNoLimit(e.target.checked)}
          style={{ marginRight: 20, marginTop: 13 }}
        />
        {t("no-limit")}
      </div>
      <div style={{ marginTop: 13 }}>
        {t("per-order-amount")}:
        <input
          type="number"
          value={newBot.dcaOrder}
          onChange={(e) => changeDcaOrder(e.target.value)}
          style={{ marginLeft: 10, marginRight: 10 }}
        />
        {currentCoin}
      </div>
    </div>
  );
};

export default DcaParamsView;
